wbApp.controller('LevelsCtrl', ['$scope', '$modal', '$translate', '$timeout', '$q', 'levelSvc',
function ($scope, $modal, $translate, $timeout, $q, levelSvc) {

    function refreshData(reselect)
    {
        return $q(function (resolve, reject) {
            var selectedRowKeys = null;
            if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                selectedRowKeys = $scope.gridSettings.gridInstance.getSelectedRowKeys();
            }

            var all = levelSvc.getAll(true);
            all.$promise.then(function (data) {
                $scope.levels = data;

                if (!!selectedRowKeys && !!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                    $timeout(function () {
                        $scope.gridSettings.gridInstance.selectRows(selectedRowKeys, false).then(function (rows) {
                            if (!rows || !rows.length) {
                                setSelectedLevel(null);
                            }
                        })
                    }, 100);
                }
                else {
                    setSelectedLevel(null);
                }

                resolve();

            }, function (error) {
                $scope.levels = [];
                setSelectedLevel(null);

                reject();
            });
        });
    }

    refreshData();

    $scope.$on('refreshData', function (e, data) {
        refreshData(true);
    });

    $scope.gridSettings = {
        name: 'levels',
        keyExpr: 'id',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '160px', sortOrder: 'asc' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string', width: '60px' },
        ]
    }


    $scope.onRowSelected = function (data) {
        setSelectedLevel(data);
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = levelSvc.createNew();
            detailDialogPromise.$scope.onLevelSave = function (model) {
                refreshData().then(function() {
                    if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedLevel(null);
                                }
                            });
                        }, 100);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onLevelSave = function () {
                refreshData(true);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        levelSvc.remove(data.id).$promise.then(function () {
            refreshData();
        });
    }

    function setSelectedLevel(level, refresh) {
        $scope.selectedLevel = level;
        $scope.$broadcast('levelSelectionChanged', $scope.selectedLevel);
    }


    var detailDialogPromise = $modal({
        templateUrl: 'levels/levels-detail.html',
        show: false,
        scope: $scope.$new()
    });


}]);
